<template>
  <div
    class="widget-3d-project"
    @click="openPopUp3dProject"
  >
    <div class="widget-3d-project__content">
      <span class="widget-3d-project__content-title">3D проект бесплатно</span>
      <button class="widget-3d-project__content-button">Заказать</button>
    </div>
    <div class="widget-3d-project__image-block">
      <img
        src="~/assets/img/png/3d-project/default-3d-project-img-low.png"
        width="200"
        height="200"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {useCreateOrder3dProject} from "~/composables/useCreateOrder3dProject";

const { openCreateOrder3dProjectOpen } = useCreateOrder3dProject();
const openPopUp3dProject = () => {
  openCreateOrder3dProjectOpen();
};

</script>

<style scoped lang="scss">
.widget-3d-project {
  position: relative;
  border-radius: 10px;
  background-color: var(--gray);
  overflow: hidden;
  cursor: pointer;
  &:hover {
    .widget-3d-project__content-button {
      background-color: var(--black);
      color: var(--text-white);
    }
  }
}
.widget-3d-project__content {
  padding: 27px 24px 26px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 60%;
}
.widget-3d-project__content-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 1.4;
  color: var(--text-black);
}
.widget-3d-project__content-button {
  padding: 15px 24px;
  background-color: var(--green);
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  color: var(--text-black);
  width: fit-content;
  cursor: pointer;
}
.widget-3d-project__image-block {
  position: absolute;
  right: 0;
  top: 0;
  width: 200px;
  height: 200px;
  & > img {
    transform: translate(18%, -18%);
  }
}
@media screen and (max-width: 559px) {
  .widget-3d-project {
    margin-top: 16px;
    &:hover {
      .widget-3d-project__content-button {
        background-color: var(--green);
        color: var(--text-black)
      }
    }
  }
  .widget-3d-project__content {
    padding: 16px;
  }
  .widget-3d-project__image-block {
    & > img {
      transform: translate(18%, -26%);
    }
  }
}
@media screen and (max-width: 364px) {
  .widget-3d-project__image-block {
    & > img {
      transform: translate(18%, -18%);
    }
  }
}
</style>
